module.exports = __webpack_public_path__ + "static/media/CeraPro-Black.c4599e63.woff2";